<template>
  <div>
    <p v-if="data.trackId" class="link ellipsis-1line" @click="goDetail(data.trackId)">{{ data.trackName }}</p>
    <p v-else class="ellipsis-1line" style="color:#141414;">{{ data.trackName }}</p>
    <p class="common-info">{{ data.singerName || '无' }}-{{ data.albumName || '无' }}</p>
    <p class="common-info" :style="{ opacity: data.wordAuthor || data.musicAuthor ? 1 : 0, marginBottom: '5px' }">
      ({{ data.wordAuthor ? `词作者：${data.wordAuthor}` : '' }}{{ data.musicAuthor ? `；曲作者：${data.musicAuthor}` : '' }})
    </p>
    <p class="common-info">
      <el-tag v-if="data.meidaType >= 0">{{ mediaTypeMap[data.meidaType] }}</el-tag>&nbsp;
      <el-tag v-if="data.srcVersion" type="info">版本：{{ data.srcVersion }}</el-tag>&nbsp;
      <svg-icon v-if="data.appealPlat > 0" class="plat-icon" :icon-class="`${platIconMap[data.appealPlat]}`"></svg-icon>
      <span :style="{ opacity: data.showTmeId >= 0 ? 1 : 0 }">TMEID：{{ data.showTmeId || '匹配无结果' }}</span>
    </p>
  </div>
</template>

<script>
import {
  mediaTypeMap
} from '../const'

const platIconMap = {
  1: 'qq',
  2: 'kg',
  3: 'kw',
  4: 'lr',
  5: 'kge'
}

export default {
  name: 'TrackInfoMod',
  props: {
    data: Object
  },
  data() {
    return {
      mediaTypeMap,
      platIconMap
    }
  },
  methods: {
    goDetail(id) {
      this.$router.push({ name: 'trackEdit', query: { id } })
    }
  }
}
</script>
<style lang="scss" scoped>
.common-info {
  color: #5C6679;
  line-height: 1.75;
}
.plat-icon {
  width: 18px;
  height: 18px;
  margin: -4px 2px 0;
}
</style>
